<template>
  <div class="content-wrapper">
    <sub-header :title="$t('menu.cashhero')" />
    <section class="content container-fluid">
      <template v-if="show">
        <cash-hero-chart />
        <template v-if="can([$Permissions.backend.dashboard.viewCompareTable])">
          <cash-hero-compare />
        </template>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-md-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <h3 class="box-title">
                  {{ $t('string.welcomeTo') }} <strong>CashHero.</strong>
                </h3>
              </div>
              <div class="box-body">
                <div class="alert alert-success alert-dismissible">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <p>{{ $t('string.introduction') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import SubHeader from '../components/SubHeader'
import CashHeroChart from './dashboard/cashheroChart'
import CashHeroCompare from './dashboard/cashheroCompare'

export default {
  name: 'Dashboard',
  components: {
    CashHeroCompare,
    CashHeroChart,
    SubHeader
  },
  metaInfo () {
    return {
      title: this.$t('string.dashboard'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  computed: {
    show () {
      const permissions = [
        'view-applicant-chart',
        'view-draft-chart',
        'view-new-client-chart',
        'view-old-client-chart',
        'view-loan-chart',
        'view-reject-chart',
        'view-approval-rate-chart',
        'view-investor-chart',
        'view-applicant-cancellation-chart',
        'view-loan-cancellation-chart',
        'view-compare-table'
      ]
      return this.can(permissions)
    }
  }
}
</script>

<style scoped></style>
